import API from "@/models/API";

export default class Reward {
    constructor(item = {}) {
        this.reward_id = item.reward_id || undefined;
        this.title = item.title || '';
        this.points = item.points!='-' && item.points || 0;
        this.gift_ids = item.gift_ids || item.coupons&& item.coupons.map(e => e.gift_id) || [];
        this.coupon_claim_valid_days = item.coupon_claim_valid_days || null;
        this.coupon_notification = item.coupon_notification || undefined;
        this.system_notification_ids = item.system_notification_ids || [];
        this.notifier_type = item.notifier_type || "priority";
        this.override_user_notification_settings = item.override_user_notification_settings || false;
        this.sms = item.sms || undefined
        this.email = item.email  || undefined
        this.push = item.push  || undefined
        this.viber = item.viber  || undefined
        

    }

    static getAll = (payload) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/rewards${payload.query}`
        );
        
        static getSystemNotifications = () =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/campaigns/campaign-system-notifications`
        );
    
        static getStore = id =>
            API.get(
                `/companies/${localStorage.getItem("storeId")}/stores/${id}`
            );
            

    static getCoupons = (query) =>
    API.get(
        `/companies/${localStorage.getItem("storeId")}/campaigns/customer-rewards`
    );
    
    static uploadTestFile = (file) =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/rewards/test-notifier/images`,
            file
        );
        
    static sendTestMessage = (body) =>
    API.post(
        `/companies/${localStorage.getItem("storeId")}/rewards/test-notifier`,
        body
    );
    
    static uploadImage = (image, type) =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/rewards/images/${type}`,
            image
        );

        
        static create = item =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/rewards/`,
            item
        );
        
        static update = item =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/rewards/${item.reward_id}`,
            item
        );

        
        static delete = item =>
        API.delete(
            `/companies/${localStorage.getItem("storeId")}/rewards/${item.reward_id}`
        );
}
